export const DISABLED_PAGE_URL = '/dashboard/disabled'
